export default __webpack_public_path__ + "static/color-tokens-in-screen-light-a8f655089174afd3fa8710dc030fe65f.png";